import React from 'react';

const FormError = ({ messages }) => {
	console.log(messages);
	return (
		<div className="error">
			{messages.map(({ message }, id) => {
				return (
					<h1 key={id} className="error__message">
						{message}
					</h1>
				);
			})}
		</div>
	);
};

export default FormError;



// WEBPACK FOOTER //
// ./src/components/FormError.js